import { ChangeDetectorRef, EventEmitter, Input, Output } from "@angular/core";
import { Component, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { DevicePilomat } from "src/app/model/devicePilomat";
import { DeviceService } from "src/app/service/device.service";
import { Subscription, interval } from 'rxjs';
import { Log } from "src/app/util/log";
import { startWith, switchMap } from 'rxjs/operators';
import { Overlay } from "@angular/cdk/overlay";
import { MatDialog } from "@angular/material/dialog";
import { SerialsList } from "src/app/model/serialsList";
import { DeviceState } from "src/app/model/deviceState";


@Component({
  selector: "app-add-user-devices-map",
  templateUrl: "./add-user-devices-map.component.html",
  styleUrls: ["./add-user-devices-map.component.css"],
})
export class AddUserDevicesMapComponent implements OnInit {

  @ViewChild("devicesmaploader", { static: true }) loader;

  @Input() deviceList;
  @Input() groupSelected;
  @Input() usergroup: boolean;
  @Input() canUserEdit;

  @Output() onDeviceSelected = new EventEmitter<DevicePilomat>();
  @Output() onDeviceDeselected = new EventEmitter<DevicePilomat>();
  @Output() selectedDeviceEmitter = new EventEmitter<DevicePilomat>();

  map: google.maps.Map;
  latitude: number;
  longitude: number;
  mapZoom: number;
  timeInterval: Subscription;
  deviceStateSubscription: Subscription;

  constructor(
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private overlay: Overlay,
    private deviceService: DeviceService
  ) { }

  ngOnInit() { }

  ngOnDestroy(): void {

    if (this.timeInterval) {
      this.timeInterval.unsubscribe();
    }

    if (this.deviceStateSubscription) {
      this.deviceStateSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this.loader.hideLoading();

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.timeInterval) {
      this.timeInterval.unsubscribe();
    }

    if (this.deviceStateSubscription) {
      this.deviceStateSubscription.unsubscribe();
    }
    setTimeout(() => {
      this.startUpdatingDevicesStates();
    }, 500);
  }

  onMarkerClicked(device) {

    Log.debug("onMarkerClicked: " + JSON.stringify(device));
  }

  startUpdatingDevicesStates() {

    Log.debug("startUpdatingDevicesStates add-user-map");

    let serials: SerialsList = new SerialsList();

    for (let i = 0; i < this.deviceList.length; i++) {
      serials.devices.push(this.deviceList[i].serial);
    }

    Log.debug("serials: " + JSON.stringify(serials));

    // this.timeInterval = interval(15000).subscribe((res) => {
    //   this.deviceStateSubscription = this.deviceService.getDevicesState(serials).subscribe((response) => {
    //     this.updateDeviceIcons(response);
    //   });
    this.timeInterval = interval(15000).pipe(
      startWith(0),
      switchMap(() => this.deviceService.getDevicesState(serials))
    ).subscribe(res => this.updateDeviceIcons(res), err => Log.debug('err: ' + JSON.stringify(err)));


    // this.deviceStateSubscription.unsubscribe();
  // }
    // );
}


addSelectedDevice(device) {

  if (device.selected) {
    device.selected = false;
    device.shortPermissions = " - ";
    this.onDeviceDeselected.emit(device);

  } else {
    device.selected = true;
    this.onDeviceSelected.emit(device);
  }
}

updateDeviceIcons(data: DeviceState[]) {

  for (let i = 0; i < data.length; i++) {

    for (let j = 0; j < this.deviceList.length; j++) {

      if (data[i].serial == this.deviceList[j].serial) {

        this.deviceList[j].updateState(data[i]);
      }
    }
  }
}

  public mapReadyHandler(map: google.maps.Map): void {
  setTimeout(() => {
  this.map = map;
  const bounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();
  for (const device of this.deviceList) {
    bounds.extend(new google.maps.LatLng(device.latitude, device.longitude));
  }
  this.map.fitBounds(bounds);

  if (this.map.getZoom() > 20) {
    this.map.setZoom(20);
  } else if (this.map.getZoom() < 4) {
    this.map.setZoom(4);
  }
}, 500);
  }

}
